import allLocales from 'virtual:i18n-locales'
const { zh: zhData = {}, en: enData = {}, th: thData = {}, ms: msData = {} } = allLocales || {}

export const getInitData = () => {
  const now = Date.now()
  const win = window as any
  const oldI18nData = win.__i18nData__ || {}

  const data = {
    'zh-CN': {
      update_time: now,
      data: {
        ...oldI18nData['zh-CN']?.data,
        ...zhData
      }
    },
    'en-US': {
      update_time: now,
      data: {
        ...oldI18nData['en-US']?.data,
        ...enData
      }
    },
    'th-TH': {
      update_time: now,
      data: {
        ...oldI18nData['th-TH']?.data,
        ...thData
      }
    },
    'ms-MY': {
      update_time: now,
      data: {
        ...oldI18nData['ms-MY']?.data,
        ...msData
      }
    }
  }
  // UPDATE window.__i18nData__
  win.__i18nData__ = data
  return data
}
